export class StringAdapter {
  isEmpty(value: string): boolean {
    return value.trim() === "";
  }

  isString(value: any): boolean {
    return typeof value === "string";
  }

  isNotEmpty(value: string): boolean {
    return !this.isEmpty(value);
  }

  trim(value: string): string {
    if (!this.isString(value)) {
      return "";
    }
    return value.trim();
  }

  split(value: string, separator?: string): string[] {
    if (!this.isString(value)) {
      return [];
    }

    const defaultSeparator = ",";
    return this.trim(value).split(separator ?? defaultSeparator);
  }

  join(value: string[], separator?: string): string {
    if (typeof value !== "object" || value.length === 0) {
      return "";
    }

    const defaultSeparator = ",";
    return value.map(item => this.trim(item)).join(separator ?? defaultSeparator);
  }

  toLowerCase(value: string): string {
    if (!this.isString(value)) {
      return "";
    }
    return value.toLowerCase();
  }

  toUpperCase(value: string): string {
    if (!this.isString(value)) {
      return "";
    }
    return value.toUpperCase();
  }
}
